var map = {
	"./config.development": 3165,
	"./config.development.ts": 3165,
	"./config.local": 103,
	"./config.local.ts": 103,
	"./config.production": 945,
	"./config.production.ts": 945,
	"./config.staging": 3741,
	"./config.staging.ts": 3741
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9723;